import dateFromApiFormat from "../date-from-api-format";

export default (sectionsData, details) => {
    // The api wording is wrong (opposite of what it should be)
    // {clockTimeEnd: 15, clockTimeStart: 0, videoTimeEnd: "08:29:16", videoTimeStart: "08:28:01"}
    // We fix the wording and convert to date objects
    // TODO: do we need to verify we cover whole duration?
    const dateRaw = details.Data.Date; 
    const range = [];
    let domain = [];
    const sectionDefinitions = sectionsData.map((section, index) => {
        const clockStart = dateFromApiFormat(dateRaw, section.videoTimeStart)
        const clockEnd = dateFromApiFormat(dateRaw, section.videoTimeEnd)

        if (index === 0) {
            range.push(clockStart);
            domain.push(section.clockTimeStart);
        }

        range.push(clockEnd);
        domain.push(section.clockTimeEnd);

        return {
            clockTimeExtents: [
                clockStart,
                clockEnd,
            ],
            videoTimeExtents: [
                section.clockTimeStart,
                section.clockTimeEnd,
            ],
        }
    })   

    return {
        range,
        domain,
        sectionDefinitions,
    } 
}


// WEBPACK FOOTER //
// ./src/modules/data/process-video-sections.js